import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import { Tab, Tabs } from 'react-toolbox/lib/tabs';
// import SearchUserByName from 'components/SearchUserByName';
import SearchUserByFullName from 'components/SearchUserByFullName';
import Error from 'components/ErrorMessage';
import Tiles from '../Tiles';
// import moment from 'moment/moment';
// import Button from 'components/CustomButton';

import styles from './Explorer.scss';

const divisions = ['D1', 'D2', 'D3', 'NAIA', 'JUCO'];
const evaluation = ['NONE', 'EVALUATED', 'NON EVALUATED'];
const paid = ['NONE', 'PAID ATHLETES', 'UNPAID ATHLETES'];
// to import local scss fle

// const tabs = ['Search Student By Division', 'Search Student By Name'];

class UpgradeStudent extends Component {
  static propTypes = {
    getStudentForStudentExplorer: PropTypes.func.isRequired,
    filterBasedStudents: PropTypes.shape.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      planIndex: 0,
      index: 0,
      fixedIndex: 1,
      inverseIndex: 1,
      divisionIndex: 0,
      evaluationIndex: 0,
      selectedPlan: {},
    };
  }

  componentDidMount() {
    const payload = {
      division: 'D1',
    };
    // if (this.state.index === 0) {
    this.props.getStudentForStudentExplorer(payload);
    // }
  }
  handleTabChange = (index) => {
    this.setState({ index });
  };

  handleFixedTabChange = (index) => {
    this.setState({ fixedIndex: index });
  };

  handleInverseTabChange = (index) => {
    this.setState({ inverseIndex: index });
  };

  // handleActive = () => {
  //   // eslint-disable-next-line no-console
  //   console.log('Special one activated');
  // };
  handleFilterChange = (name, index) => {
    const { planIndex, divisionIndex, evaluationIndex } = this.state;
    let applyFilter = false;
    if (name === 'planIndex' && planIndex !== index) applyFilter = true;
    if (name === 'divisionIndex' && divisionIndex !== index) applyFilter = true;
    if (name === 'evaluationIndex' && evaluationIndex !== index) applyFilter = true;
    if (applyFilter) this.setState({ [name]: index }, this.applyFilters);
  };

  applyFilters = () => {
    const { divisionIndex, evaluationIndex, planIndex } = this.state;
    const payload = {};
    payload['division'] = divisions[divisionIndex]; // eslint-disable-line
    if(evaluationIndex) payload['evaluated'] = evaluationIndex === 1 ? true : false; // eslint-disable-line
    if(planIndex) payload['paid'] =  planIndex === 1  ? true : false; // eslint-disable-line
    this.props.getStudentForStudentExplorer(payload);
  };

  render() {
    const { planIndex, divisionIndex, evaluationIndex } = this.state;
    const { filterBasedStudents, isLoading } = this.props;
    const renderNoStudentFound = renderIf(filterBasedStudents.size === 0 && !isLoading);
    const renderStudents = renderIf(filterBasedStudents.size > 0);

    return (
      <div>
        <Tabs index={this.state.index} onChange={this.handleTabChange}>
          <Tab label="Search By Division"><small>
            <div className={cn('col s12', styles.removePadding)}>
              <span className={styles.filterType}>FILTER FOR DIVISION</span> <br />
              {divisions.map((item, i) => (
                <button
                  className={divisionIndex === i ? styles.selectedButton : styles.plainButton}
                  onClick={() => this.handleFilterChange('divisionIndex', i)}
                >
                  {item}
                </button>
              ))} <br /> <br />
              <span className={styles.filterType}>FILTER FOR EVALUATION</span><br />
              {evaluation.map((item, i) => (
                <button
                  className={evaluationIndex === i ? styles.selectedButton : styles.plainButton}
                  onClick={() => this.handleFilterChange('evaluationIndex', i)}
                >
                  {item}
                </button>
              ))} <br /> <br />
              <span className={styles.filterType}>FILTER FOR PAID/UNPAID</span> <br />
              {paid.map((item, i) => (
                <button
                  className={planIndex === i ? styles.selectedButton : styles.plainButton}
                  onClick={() => this.handleFilterChange('planIndex', i)}
                >
                  {item}
                </button>
              ))}
              {renderNoStudentFound(
                <Error message="No Athlete found on above filter. Try different filter." />,
              )}
              {renderStudents(
                <div className={cn('col s12', styles.container)}>
                  {filterBasedStudents.map(item => (
                    <Tiles item={item} />
                  ))}
                </div>,
              )}
            </div>,
          </small></Tab>
          {/* <Tab label="Search By Name"><small>
            <SearchUserByName {...this.props} userType="STUDENT" />
          </small></Tab> */}
          <Tab label="Search By Name"><small>
            <SearchUserByFullName {...this.props} userType="STUDENT" />
          </small></Tab>
        </Tabs>
      </div>
    );
  }
}

export default UpgradeStudent;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/StudentView/components/StudentExplorer/Explorer.js